import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Bericht, BerichtInformatie, BerichtInformatiePagina, BerichtenPagina, BerichtPatch, Status } from './berichtbeheer.model';

@Injectable({ providedIn: 'root' })
export class BerichtbeheerResource {
    private readonly baseUrl: string = '/services/apic-berichtbeheer/api';

    public constructor(private readonly httpClient: HttpClient) {}

    public getBerichtenInformatie(status?: Status, amount = '100'): Observable<BerichtInformatiePagina> {
        let params = new HttpParams().set('size', amount).set('sort', '-aangemaaktOp');
        if (status) {
            params = params.set('status', status);
        }
        return this.httpClient.get<BerichtInformatiePagina>(`${this.baseUrl}/berichten/informatie`, { params });
    }

    public getBerichten(amount = '100'): Observable<BerichtenPagina> {
        const params = new HttpParams().set('size', amount).set('sort', '-aangemaaktOp');
        return this.httpClient.get<BerichtenPagina>(`${this.baseUrl}/berichten`, {
            params
        });
    }

    public getBericht(berichtId: string): Observable<Bericht> {
        return this.httpClient.get<Bericht>(`${this.baseUrl}/bericht/${berichtId}`);
    }

    public getBerichtInformatie(berichtId: string): Observable<BerichtInformatie> {
        return this.httpClient.get<BerichtInformatie>(`${this.baseUrl}/bericht/${berichtId}/informatie`);
    }

    public patchBericht(berichtId: string, berichtPatch: BerichtPatch): Observable<void> {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const headers = { 'Content-Type': 'application/merge-patch+json' };
        return this.httpClient.patch<void>(`${this.baseUrl}/bericht/${berichtId}`, { bericht_informatie: berichtPatch }, { headers });
    }
}
